import { GooseUser } from "./goose/GooseUser";

export class Goose {
  public user = new GooseUser();
}